module.exports = __webpack_public_path__ + "static/media/analysis-icon.edcf9a0f.svg";